const formFieldComponentMixin = {
  props: {
    label: {
      type: String,
      required: false,
      default: null,
    },
    name: {
      type: String,
      required: true,
    },
    value: {
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    width: {
      type: String,
      required: false,
      default: null,
    },
    error: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      isFocused: false,
      lastError: null,
    }
  },
  computed: {
    fieldId() {
      return this.name
    },
    containerClasses() {
      const classes = []

      if (this.isFocused) {
        classes.push('form__input-container--focus')
      }
      if (this.value) {
        classes.push('form__input-container--filled')
      }
      if (this.disabled) {
        classes.push('form__input-container--disabled')
      }
      if (this.error) {
        classes.push('form__input-container--error')
      }

      return classes.join(' ')
    },
    errorAsString() {
      return String(this.error || this.lastError)
    },
  },
  methods: {
    focusHandler() {
      this.isFocused = true
      this.$emit('focus')
    },
    blurHandler() {
      this.isFocused = false
      this.$emit('blur')
    },
    inputHandler(value) {
      this.$emit('input', value)
    },
    changeHandler(value) {
      this.$emit('change', value)
    },
  },
}

export default formFieldComponentMixin
